// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"592": "0c48a7a22886bb2b","754": "ad70d6f55b68bea3",}[chunkId] + ".css"
}